import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import tokens from "../styles/tokens.css?raw";

// tailwind-merge only knows Tailwind's stock names. Ours are tokens -- `text-muted-foreground`,
// `bg-primary-tint`, `text-body2` -- and without being told what they are it cannot see that
// a caller's `text-error` conflicts with a component's `text-primary-foreground`, or that
// `text-caption` is a size and not a colour. Both classes survive and stylesheet order
// decides; the web client found this as a white-on-white Delete button. The names are
// read from the stylesheet itself so the list cannot fall behind it.
const names = (pattern: RegExp) => [...tokens.matchAll(pattern)].map((match) => match[1]);

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: names(/--color-([a-z0-9-]+)\s*:/g),
      // `--text-h4:` but not `--text-h4--line-height:`.
      text: names(/--text-([a-z0-9]+(?:-[a-z0-9]+)*)\s*:/g),
    },
  },
});

/** Joins class names and lets the later Tailwind utility win a conflict, our tokens included. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
